import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AppControllerService } from "../../../app-controller.service";
import { AuthService } from "../auth/auth.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { HttpClient } from "@angular/common/http";
import { take } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { ApiAttachmentUploadSessionConstants } from "../../constants/api-constants/api-attachment-upload-session.constants";
import { lastValueFrom } from "rxjs";
let FileUploadService = class FileUploadService {
    appController;
    requestStatusService;
    http;
    authService;
    authenticationToken;
    constructor(appController, requestStatusService, http, authService) {
        this.appController = appController;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.authService = authService;
        this.authService.$authenticationToken.subscribe((tokenChange) => {
            this.authenticationToken = tokenChange;
        });
    }
    uploadFile(url, formData, source, mergeType, attachmentId = null, split = false, returnFunction, additionalMergeParams = null) {
        if (split) {
            const fileKey = "file";
            const file = formData.get(fileKey);
            const chunks = this.splitFile(file);
            const startParams = {
                fileName: file.name,
                fileSize: file.size,
                totalChunks: chunks.length
            };
            this.http.post(`${ApiAttachmentUploadSessionConstants.URL}/${ApiAttachmentUploadSessionConstants.FUNCTION_START_UPLOAD}`, startParams).pipe(take(1)).subscribe({
                next: async (session) => {
                    try {
                        for (let i = 0; i < chunks.length; i++) {
                            const form = new FormData();
                            form.append("uploadSessionId", session.id.toString());
                            form.append("chunkIndex", i.toString());
                            form.append("chunk", chunks[i]);
                            await lastValueFrom(this.http.post(`${ApiAttachmentUploadSessionConstants.URL}/${ApiAttachmentUploadSessionConstants.FUNCTION_UPLOAD_CHUNK}`, form));
                        }
                        const mergeParams = {
                            uploadSessionId: session.id,
                            fileName: file.name,
                            totalChunks: chunks.length,
                            type: mergeType
                        };
                        const selectedJobId = this.appController.selectedJobID;
                        // Organisation settings restore has no selected job, so avoid sending an empty string to the API.
                        if (selectedJobId !== null && selectedJobId !== undefined && selectedJobId !== "") {
                            mergeParams.jobId = selectedJobId;
                        }
                        if (attachmentId !== null && attachmentId !== undefined) {
                            mergeParams.attachmentId = attachmentId;
                        }
                        if (source !== null && source !== undefined && source !== "") {
                            mergeParams.source = source;
                        }
                        if (additionalMergeParams) {
                            Object.keys(additionalMergeParams).forEach(key => {
                                mergeParams[key] = additionalMergeParams[key];
                            });
                        }
                        // @ts-ignore
                        for (const [key, value] of formData.entries()) {
                            if (key.toLowerCase() !== "file") {
                                mergeParams[key] = value;
                            }
                        }
                        this.http.post(`${ApiAttachmentUploadSessionConstants.URL}/${ApiAttachmentUploadSessionConstants.FUNCTION_MERGE_CHUNKS}`, mergeParams).pipe(take(1)).subscribe({
                            next: result => {
                                returnFunction(result);
                            },
                            error: (error) => {
                                this.appController.handleServerErrorMessage("File", error, CRUDOperation.Saving);
                                returnFunction(null);
                            }
                        });
                        // returnFunction(result);
                    }
                    catch (error) {
                        this.appController.handleServerErrorMessage("File", error, CRUDOperation.Saving);
                        returnFunction(null);
                    }
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("File", error, CRUDOperation.Saving);
                    returnFunction(null);
                }
            });
        }
        else {
            this.http.post(url, formData).pipe(take(1)).subscribe({
                next: (result) => {
                    returnFunction(result);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("File", error, CRUDOperation.Saving);
                    returnFunction(null);
                }
            });
        }
    }
    splitFile(file, chunkSize = 2 * 1024 * 1024) {
        const chunks = [];
        let start = 0;
        while (start < file.size) {
            const end = Math.min(start + chunkSize, file.size);
            chunks.push(file.slice(start, end));
            start = end;
        }
        return chunks;
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AuthService }
    ];
};
FileUploadService = __decorate([
    Injectable({
        providedIn: "root"
    })
], FileUploadService);
export { FileUploadService };
